frappe.ready(function () {
  var page = document.querySelector('[data-doctype="Website Item"][source-type="Generator"]');
  if (!page) return;

  // For non-variant items, .item-cart[data-variant-item-code] is present from
  // first render. For variant templates it doesn't exist yet - it's created
  // (and re-targeted to a different item-code as the shopper switches
  // swatches) by pdp_variant_swatches.js. So everything here reads the
  // current container/item-code live from the DOM rather than caching them
  // once, and listeners are delegated from `document` instead of bound
  // directly to a container that may not exist at script-init time.
  function getContainer() {
    return document.querySelector('.item-cart[data-variant-item-code]');
  }

  function getItemCode() {
    var container = getContainer();
    return container ? container.getAttribute('data-variant-item-code') : null;
  }

  function getShoppingCart() {
    return (
      window.shopping_cart ||
      (window.webshop && webshop.webshop && webshop.webshop.shopping_cart)
    );
  }

  function getQtyFromCartSnapshot(cartDoc, itemCode) {
    if (!cartDoc || !Array.isArray(cartDoc.items)) return 0;
    for (var i = 0; i < cartDoc.items.length; i++) {
      var row = cartDoc.items[i];
      if (row && row.item_code === itemCode) {
        var q = parseFloat(row.qty || 0);
        return isNaN(q) ? 0 : Math.max(0, q);
      }
    }
    return 0;
  }

  function setButtonVisibility(container, qty) {
    var addBtn = container.querySelector('.btn-add-to-cart');

    if (addBtn) {
      addBtn.classList.toggle('hidden', qty > 0);
    }
  }

  // Drop a qty-spinner left over from a previously-selected variant. Needed
  // because switching swatches re-targets the *same* container to a new
  // item-code without recreating it (mirrors the listing card's
  // clearStaleListingCartUi fix for the same underlying issue).
  function clearStaleSpinner(container, itemCode) {
    var existing = container.querySelector('.pdp-qty-wrapper');
    if (existing && existing.getAttribute('data-item-code') !== itemCode) {
      existing.parentNode.removeChild(existing);
    }
  }

  function ensureSpinner(container, itemCode, qty) {
    clearStaleSpinner(container, itemCode);

    var existing = container.querySelector('.pdp-qty-wrapper[data-item-code="' + itemCode + '"]');
    if (existing) {
      var inputExisting = existing.querySelector('.cart-qty');
      if (inputExisting) {
        inputExisting.value = String(qty);
        inputExisting.dataset.syncedQty = String(qty);
        inputExisting.dataset.pendingUpdate = '0';
      }
      existing.classList.toggle('hidden', qty <= 0);
      return existing;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'pdp-qty-wrapper mt-2';
    wrapper.setAttribute('data-item-code', itemCode);

    wrapper.innerHTML = [
      '<div class="d-flex align-items-center">',
      '  <div class="input-group number-spinner">',
      '    <span class="input-group-prepend d-sm-inline-block">',
      '      <button class="btn cart-btn" data-dir="dwn">&minus;</button>',
      '    </span>',
      '    <input class="form-control text-center cart-qty"',
      '           value="' + qty + '"',
      '           data-item-code="' + frappe.utils.escape_html(itemCode) + '"',
      '           style="max-width: 70px;">',
      '    <span class="input-group-append d-sm-inline-block">',
      '      <button class="btn cart-btn" data-dir="up">+</button>',
      '    </span>',
      '  </div>',
      '  <a href="/cart" class="pdp-go-to-cart ml-2" aria-label="Go to cart">',
      '    <svg class="icon sm" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">',
      '      <path d="M6 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM3 3h1.2l.9 6h7.8l1.1-4.4A.5.5 0 0 0 13.5 4h-8" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>',
      '    </svg>',
      '  </a>',
      '</div>'
    ].join('');

    var target = container.querySelector('.mb-4.d-flex') || container;
    target.appendChild(wrapper);

    var inputAfterCreate = wrapper.querySelector('.cart-qty');
    if (inputAfterCreate) {
      inputAfterCreate.dataset.syncedQty = String(qty);
      inputAfterCreate.dataset.pendingUpdate = '0';
    }

    wrapper.classList.toggle('hidden', qty <= 0);
    return wrapper;
  }

  var refreshInFlight = false;
  var refreshQueued = false;
  var refreshTimer = null;

  function refreshPdpFromServerCart() {
    if (refreshTimer) {
      clearTimeout(refreshTimer);
    }

    refreshTimer = setTimeout(function () {
      if (refreshInFlight) {
        refreshQueued = true;
        return;
      }
      refreshInFlight = true;
      var finalized = false;

      function finalize() {
        if (finalized) return;
        finalized = true;
        refreshInFlight = false;
        if (refreshQueued) {
          refreshQueued = false;
          refreshPdpFromServerCart();
        }
      }

      function applyFromCartDoc(cartDoc) {
        var container = getContainer();
        var itemCode = getItemCode();
        if (!container || !itemCode) return;

        var qty = getQtyFromCartSnapshot(cartDoc, itemCode);
        setButtonVisibility(container, qty);
        ensureSpinner(container, itemCode, qty);
      }

      function fallbackToFullCartAndFinalize() {
        var req2 = frappe.call({
          type: 'GET',
          method: 'webshop.webshop.shopping_cart.cart.get_cart_quotation',
          callback: function (r2) {
            if (r2 && r2.message && r2.message.doc) {
              applyFromCartDoc(r2.message.doc);
            }
          },
        });

        if (req2 && typeof req2.always === 'function') {
          req2.always(finalize);
        } else {
          finalize();
        }
      }

      if (!getContainer()) {
        // No variant resolved yet (or non-variant item without a price) -
        // nothing to sync against the cart.
        finalize();
        return;
      }

      var req = frappe.call({
        type: 'GET',
        method: 'raftor_webhq.checkout.simple_checkout.get_cart_items_snapshot',
        callback: function (r) {
          if (r && r.message && r.message.items) {
            applyFromCartDoc({ items: r.message.items });
            finalize();
            return;
          }
          fallbackToFullCartAndFinalize();
        },
        error: function () {
          fallbackToFullCartAndFinalize();
        },
      });

      if (!req || typeof req.always !== 'function') {
        finalize();
      }
    }, 120);
  }

  function updateQty(newQty) {
    if (newQty < 0) newQty = 0;

    var container = getContainer();
    var itemCode = getItemCode();
    if (!container || !itemCode) return;

    var shoppingCart = getShoppingCart();
    if (!shoppingCart || typeof shoppingCart.update_cart !== 'function') {
      return;
    }

    var wrapperBeforeUpdate = container.querySelector('.pdp-qty-wrapper[data-item-code="' + itemCode + '"]');
    var inputBeforeUpdate = wrapperBeforeUpdate ? wrapperBeforeUpdate.querySelector('.cart-qty') : null;
    if (inputBeforeUpdate) {
      inputBeforeUpdate.dataset.pendingUpdate = '1';
    }

    shoppingCart.update_cart({
      item_code: itemCode,
      qty: newQty,
      with_items: 0,
      callback: function (r) {
        if (r && r.exc) {
          if (inputBeforeUpdate) inputBeforeUpdate.dataset.pendingUpdate = '0';
          refreshPdpFromServerCart();
          return;
        }

        var freshContainer = getContainer();
        if (!freshContainer || getItemCode() !== itemCode) {
          // Shopper switched variants while this update was in flight;
          // let the next refresh reconcile against whatever is current.
          refreshPdpFromServerCart();
          return;
        }

        var wrapper = freshContainer.querySelector('.pdp-qty-wrapper[data-item-code="' + itemCode + '"]');
        if (wrapper) {
          var input = wrapper.querySelector('.cart-qty');
          if (input) {
            input.value = String(newQty);
            input.dataset.syncedQty = String(newQty);
            input.dataset.pendingUpdate = '0';
          }
          wrapper.classList.toggle('hidden', newQty <= 0);
        }

        setButtonVisibility(freshContainer, newQty);
        refreshPdpFromServerCart();
      },
    });
  }

  document.addEventListener('click', function (event) {
    var upDownBtn = event.target.closest('.item-cart .pdp-qty-wrapper .number-spinner button');
    if (!upDownBtn) return;

    var wrapper = upDownBtn.closest('.pdp-qty-wrapper');
    if (!wrapper) return;

    var input = wrapper.querySelector('.cart-qty');
    var current = parseInt(input && input.value ? input.value : '0', 10);
    if (isNaN(current) || current < 0) current = 0;

    var dir = upDownBtn.getAttribute('data-dir');
    if (dir === 'up') {
      var upVal = current + 1;
      if (input) input.value = String(upVal);
      updateQty(upVal);
    } else if (dir === 'dwn') {
      var next = current - 1;
      if (next < 0) next = 0;
      if (input) input.value = String(next);
      updateQty(next);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.item-cart .pdp-qty-wrapper .cart-qty');
    if (!input) return;

    var newQty = parseInt(input.value || '0', 10);
    if (isNaN(newQty) || newQty < 0) newQty = 0;

    updateQty(newQty);
  });

  if (window.jQuery && typeof window.jQuery === 'function') {
    window.jQuery(document).on('cart-updated', function () {
      refreshPdpFromServerCart();
    });
  }

  window.addEventListener('pageshow', function () {
    refreshPdpFromServerCart();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      refreshPdpFromServerCart();
    }
  });

  refreshPdpFromServerCart();
});
